import styled from 'styled-components';

import { SkeletonRow } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Identity = styled.div`
    display: flex;
    align-items: center;
    gap: 3.2rem;
    min-height: 9.6rem;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        align-items: flex-start;
        gap: 1.6rem;
    `}
`;

export const ChartContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 1.6rem;
`;

export const Plot = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2.4rem 1.6rem;
    border-radius: 1.2rem;
    background: ${COLORS.gray50};
`;

export const GridLine = styled(SkeletonRow)`
    border-bottom: 0.1rem solid ${COLORS.gray100};
    padding-bottom: 1.6rem;
    justify-content: flex-end;
`;
